@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title">
    <div class="ideal-layout">
      <div class="before-after-grid stagger">
        @for (pair of s.pairs; track pair.before) {
          <div class="ba-card">
            <div class="ba-card__before">
              <mat-icon class="ba-card__icon ba-card__icon--before">close</mat-icon>
              <span>{{ pair.before }}</span>
            </div>
            <mat-icon class="ba-card__arrow">arrow_forward</mat-icon>
            <div class="ba-card__after">
              <mat-icon class="ba-card__icon ba-card__icon--after">check_circle</mat-icon>
              <span>{{ pair.after }}</span>
            </div>
          </div>
        }
      </div>

      <div class="benefits">
        <h3 class="benefits__title">{{ s.benefitsTitle }}</h3>
        <ul class="benefits__list">
          @for (benefit of s.benefits; track benefit) {
            <li class="benefits__item">
              <mat-icon class="benefits__check">check_circle</mat-icon>
              <span>{{ benefit }}</span>
            </li>
          }
        </ul>
        <div class="benefits__cta">
          <app-cta-button
            [label]="s.cta.label"
            variant="primary"
            [fragment]="s.cta.fragment"
          />
        </div>
      </div>
    </div>
  </app-section-wrapper>
}
